[
  {
    "id": "carnivora",
    "name": {
      "pt-BR": "Carnívora",
      "en": "Carnivora"
    },
    "icon": "powers/carnivora",
    "pantheon": "atlanteans",
    "cooldown": 180,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ClassicalAgeOceanus)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 20 favor, +5 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 180 s. Creates a permanent Carnivora plant."
    }
  },
  {
    "id": "chaos",
    "name": {
      "pt-BR": "Caos",
      "en": "Chaos"
    },
    "icon": "powers/chaos",
    "pantheon": "atlanteans",
    "cooldown": 240,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml HeroicAgeHyperion)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 60 favor, +20 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 240 s. Enemy military units in 10 m fight each other."
    }
  },
  {
    "id": "deconstruction",
    "name": {
      "pt-BR": "Desconstrução",
      "en": "Deconstruction"
    },
    "icon": "powers/deconstruction",
    "pantheon": "atlanteans",
    "cooldown": 180,
    "effect": {
      "kind": "deconstruction"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ArchaicAgeKronos)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 10 favor, +10 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 180 s. Dismantles an enemy building (fully built only; not Village Centers) over 0.4 x its build points (timefactor) and refunds its cost to the owner."
    }
  },
  {
    "id": "gaia-forest",
    "name": {
      "pt-BR": "Floresta de Gaia",
      "en": "Gaia Forest"
    },
    "icon": "powers/gaia-forest",
    "pantheon": "atlanteans",
    "cooldown": 120,
    "effect": {
      "kind": "economy"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ArchaicAgeGaia)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 0 favor, +10 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 120 s. Grows 20 Gaia Trees (TreeGaia: 250 wood, gather rate x1.05 -> a Citizen gets 97.65 wood/min). Not modelled."
    }
  },
  {
    "id": "hesperides",
    "name": {
      "pt-BR": "Árvore de Hespérides",
      "en": "Hesperides Tree"
    },
    "icon": "powers/hesperides",
    "pantheon": "atlanteans",
    "cooldown": 60,
    "effect": {
      "kind": "utility",
      "spawn": {
        "dryad": 2
      }
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml HeroicAgeTheia)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 0 favor, +125 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 60 s. Creates a Hesperides Tree (trains Dryads) and 2 Dryads."
    }
  },
  {
    "id": "implode",
    "name": {
      "pt-BR": "Implodir",
      "en": "Implode"
    },
    "icon": "powers/implode",
    "pantheon": "atlanteans",
    "cooldown": 180,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml MythicAgeAtlas)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 350 favor, +5 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 180 s. Black hole that damages units and buildings."
    }
  },
  {
    "id": "shockwave",
    "name": {
      "pt-BR": "Onda de Choque",
      "en": "Shockwave"
    },
    "icon": "powers/shockwave",
    "pantheon": "atlanteans",
    "cooldown": 180,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ArchaicAgeOranos)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 20 favor, +15 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 180 s. Throws and stuns (1 s) enemy units in a 5 m radius."
    }
  },
  {
    "id": "spider-lair",
    "name": {
      "pt-BR": "Covil de Aranhas",
      "en": "Spider Lair"
    },
    "icon": "powers/spider-lair",
    "pantheon": "atlanteans",
    "cooldown": 60,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ClassicalAgeLeto)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 4 favor, +4 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 60 s. Lays 4 spider eggs that hatch on enemy human soldiers."
    }
  },
  {
    "id": "tartarian-gate",
    "name": {
      "pt-BR": "Portão do Tártaro",
      "en": "Tartarian Gate"
    },
    "icon": "powers/tartarian-gate",
    "pantheon": "atlanteans",
    "cooldown": 240,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml MythicAgeHekate)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 300 favor, +5 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 240 s. Gate that destroys overlapping buildings and spawns up to 7 creatures hostile to all."
    }
  },
  {
    "id": "time-shift",
    "name": {
      "pt-BR": "Deslocamento Temporal",
      "en": "Time Shift"
    },
    "icon": "powers/time-shift",
    "pantheon": "atlanteans",
    "effect": {
      "kind": "timeShift",
      "buildTimeFraction": 1
    },
    "meta": {
      "source": "Game files 19.17020 (major_gods.xml Kronos timeshifting; techtree.xml TemporalChaos)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Kronos building command (not a favor god power, no cooldown). Duration = timeRatio 1.0 x the building's build points (guide: 'duration ratio according to building's build points'), so it does not depend on builders. Cost ratio 0 for Manor, Farm, Economic Guild, Military Barracks, Counter Barracks, Dock, Temple, Armory, Market; 0.50 of the building cost for Palace, Sentry Tower, Mirror Tower. Only these buildings can be shifted (not Town/Village Centers, walls, Wonder). 2 concurrent shifts. Temporal Chaos: duration x0.5, 3 concurrent, cost ratio 0.25 (not modelled). Names: en from STR_PUC_UNBUILD ('Time Shift this building'), pt-BR from STR_HK_TIMESHIFT."
    }
  },
  {
    "id": "traitor",
    "name": {
      "pt-BR": "Traidor",
      "en": "Traitor"
    },
    "icon": "powers/traitor",
    "pantheon": "atlanteans",
    "cooldown": 180,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml HeroicAgeRheia)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 15 favor, +15 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 180 s. Converts one enemy unit."
    }
  },
  {
    "id": "valor",
    "name": {
      "pt-BR": "Valentia",
      "en": "Valor"
    },
    "icon": "powers/valor",
    "pantheon": "atlanteans",
    "cooldown": 30,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml ClassicalAgePrometheus)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 1 favor, +1 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 30 s. Turns one own human unit into its hero form."
    }
  },
  {
    "id": "vortex",
    "name": {
      "pt-BR": "Vórtice",
      "en": "Vortex"
    },
    "icon": "powers/vortex",
    "pantheon": "atlanteans",
    "cooldown": 60,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/atlantean.godpowers; techtree.xml MythicAgeHelios)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "First cast free; 'cost' is omitted. Second cast 0 favor, +25 per further cast (godpowers <cost> = cost of the second cast, <repeatcost> = escalation). Cooldown 60 s. Teleports all own non-naval military units (not Oracles/Titans) to the target."
    }
  },
  {
    "id": "ancestors",
    "name": {
      "pt-BR": "Ancestrais",
      "en": "Ancestors"
    },
    "icon": "powers/ancestors",
    "pantheon": "egyptians",
    "cost": {
      "favor": 100
    },
    "cooldown": 180,
    "effect": {
      "kind": "military",
      "duration": 55
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Summons 13 Minions (ancestral soldiers; Lost Ships on water) for 55 s. Retold cost ramp: each further cast costs +5 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "citadel",
    "name": {
      "pt-BR": "Cidadela",
      "en": "Citadel"
    },
    "icon": "powers/citadel",
    "pantheon": "egyptians",
    "cost": {
      "favor": 150
    },
    "cooldown": 120,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Turns a Town Center into a Citadel Center (25 pop instead of 15, stronger, trains/researches faster). Retold cost ramp: each further cast costs +50 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "eclipse",
    "name": {
      "pt-BR": "Eclipse",
      "en": "Eclipse"
    },
    "icon": "powers/eclipse",
    "pantheon": "egyptians",
    "cost": {
      "favor": 90
    },
    "cooldown": 150,
    "castTime": 6,
    "effect": {
      "kind": "military",
      "modifiers": [
        {
          "target": "favorRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "ids": [
              "monument-to-villagers",
              "monument-to-soldiers",
              "monument-to-priests",
              "monument-to-pharaohs",
              "monument-to-gods"
            ]
          },
          "note": "Monuments generate Favor 50% faster while active."
        }
      ],
      "duration": 49
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Night for 49 s (6 s build-up): myth units +20% damage, +15% speed, -10% damage taken, ability recharge x0.4; Monuments favor x1.5. Retold cost ramp: each further cast costs +25 Favor (repeatcost). Unlimited uses, gated by the recharge."
    },
    "fieldMeta": {
      "effect": {
        "source": "Game files 19.17020 (god_powers/egyptian.godpowers)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "WorkRate effects with relativity BasePercent -> op pct. Monument favor x1.5; myth unit buffs not modelled."
      }
    }
  },
  {
    "id": "locust-swarm",
    "name": {
      "pt-BR": "Nuvem de Gafanhotos",
      "en": "Locust Swarm"
    },
    "icon": "powers/locust-swarm",
    "pantheon": "egyptians",
    "cost": {
      "favor": 75
    },
    "cooldown": 150,
    "effect": {
      "kind": "military",
      "duration": 20
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Locust swarm along a path for 20 s; damages units/buildings and destroys Farms, livestock and berries. Retold cost ramp: each further cast costs +10 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "meteor",
    "name": {
      "pt-BR": "Meteoro",
      "en": "Meteor"
    },
    "icon": "powers/meteor",
    "pantheon": "egyptians",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "castTime": 3,
    "effect": {
      "kind": "military",
      "duration": 15
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "12 meteor strikes over 15 s in radius 25 (3 s build-up); strong vs buildings. Retold cost ramp: each further cast costs +5 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "plague-of-serpents",
    "name": {
      "pt-BR": "Praga das Serpentes",
      "en": "Plague of Serpents"
    },
    "icon": "powers/plague-of-serpents",
    "pantheon": "egyptians",
    "cost": {
      "favor": 60
    },
    "cooldown": 180,
    "effect": {
      "kind": "military",
      "duration": 18
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Summons 14 Serpents (2 every 3 s for 18 s) within radius 14; they are permanent until killed. Retold cost ramp: each further cast costs +10 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "prosperity",
    "name": {
      "pt-BR": "Prosperidade",
      "en": "Prosperity"
    },
    "icon": "powers/prosperity",
    "pantheon": "egyptians",
    "cost": {
      "favor": 60
    },
    "cooldown": 120,
    "effect": {
      "kind": "economy",
      "modifiers": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["gold"]
          },
          "note": "Gold gather rate +50%; Caravans trade +20%."
        }
      ],
      "duration": 75
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Your Villagers gather Gold +50% and Caravans +20% for 75 s. Retold cost ramp: each further cast costs +10 Favor (repeatcost). Unlimited uses, gated by the recharge."
    },
    "fieldMeta": {
      "effect": {
        "source": "Game files 19.17020 (god_powers/egyptian.godpowers)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "WorkRate effects with relativity BasePercent -> op pct. Gold x1.5; caravan trade x1.2 not modelled."
      }
    }
  },
  {
    "id": "rain",
    "name": {
      "pt-BR": "Chuva",
      "en": "Rain"
    },
    "icon": "powers/rain",
    "pantheon": "egyptians",
    "cost": {
      "favor": 30
    },
    "cooldown": 90,
    "effect": {
      "kind": "economy",
      "modifiers": [
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 1.5,
          "scope": {
            "sources": ["farm"]
          },
          "note": "Farm gather rate +150% (BasePercent 2.5)."
        },
        {
          "target": "gatherRate",
          "op": "pct",
          "value": 0.5,
          "scope": {
            "sources": ["fish"]
          },
          "note": "Fishing Ships +50%."
        }
      ],
      "duration": 50
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Your Laborers' Farm gather rate +150% and Fishing Ships +50% for 50 s, map-wide. Retold cost ramp: each further cast costs +15 Favor (repeatcost). Unlimited uses, gated by the recharge."
    },
    "fieldMeta": {
      "effect": {
        "source": "Game files 19.17020 (god_powers/egyptian.godpowers)",
        "checkedAt": "2026-10-18",
        "confidence": "high",
        "note": "WorkRate effects with relativity BasePercent -> op pct. Farms x2.5 (+150%), fishing x1.5 (+50%)."
      }
    }
  },
  {
    "id": "shifting-sands",
    "name": {
      "pt-BR": "Areias Movediças",
      "en": "Shifting Sands"
    },
    "icon": "powers/shifting-sands",
    "pantheon": "egyptians",
    "cost": {
      "favor": 40
    },
    "cooldown": 180,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Teleports own/allied units within radius 10 to a target location. Retold cost ramp: each further cast costs +20 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "son-of-osiris",
    "name": {
      "pt-BR": "Filho de Osíris",
      "en": "Son of Osiris"
    },
    "icon": "powers/son-of-osiris",
    "pantheon": "egyptians",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Transforms the Pharaoh into the Son of Osiris (super-empowering lightning demigod). Retold cost ramp: each further cast costs +50 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "tornado",
    "name": {
      "pt-BR": "Tornado",
      "en": "Tornado"
    },
    "icon": "powers/tornado",
    "pantheon": "egyptians",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "effect": {
      "kind": "military",
      "duration": 20
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Tornado for 20 s that throws units and damages buildings. Retold cost ramp: each further cast costs +5 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "vision",
    "name": {
      "pt-BR": "Visão",
      "en": "Vision"
    },
    "icon": "powers/vision",
    "pantheon": "egyptians",
    "cost": {
      "favor": 40
    },
    "cooldown": 240,
    "effect": {
      "kind": "utility",
      "duration": 20
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/egyptian.godpowers, techtree.xml, string_table.txt)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Reveals a 60-radius area for 20 s. Retold cost ramp: each further cast costs +5 Favor (repeatcost). Unlimited uses, gated by the recharge."
    }
  },
  {
    "id": "bolt",
    "name": {
      "pt-BR": "Raio",
      "en": "Bolt"
    },
    "icon": "powers/bolt",
    "pantheon": "greeks",
    "cost": {
      "favor": 55
    },
    "cooldown": 90,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Zeus (ArchaicAgeZeus grants it: GodPower amount 1, cooldown 90 s). cost = file <cost>; each recast adds <repeatcost> 5 favor. Strikes one enemy unit (BoltStrike). activetime 3 s."
    }
  },
  {
    "id": "bronze",
    "name": {
      "pt-BR": "Bronze",
      "en": "Bronze"
    },
    "icon": "powers/bronze",
    "pantheon": "greeks",
    "cost": {
      "favor": 150
    },
    "cooldown": 150,
    "effect": {
      "kind": "military",
      "duration": 40
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Dionysus (HeroicAgeDionysus grants it: GodPower amount 1, cooldown 150 s). cost = file <cost>; each recast adds <repeatcost> 25 favor. Own human soldiers, warships and myth units in 30 m: -35% hack/pierce vulnerability (warships also crush). activetime 40 s."
    }
  },
  {
    "id": "ceasefire",
    "name": {
      "pt-BR": "Cessar-fogo",
      "en": "Ceasefire"
    },
    "icon": "powers/ceasefire",
    "pantheon": "greeks",
    "cost": {
      "favor": 75
    },
    "cooldown": 240,
    "effect": {
      "kind": "utility",
      "duration": 30
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Hermes (ClassicalAgeHermes grants it: GodPower amount 1, cooldown 240 s). cost = file <cost>; each recast adds <repeatcost> 25 favor. Prevents combat; affected buildings get BuildPoints x2. activetime 30 s."
    }
  },
  {
    "id": "curse",
    "name": {
      "pt-BR": "Maldição",
      "en": "Curse"
    },
    "icon": "powers/curse",
    "pantheon": "greeks",
    "cost": {
      "favor": 125
    },
    "cooldown": 150,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Aphrodite (HeroicAgeAphrodite grants it: GodPower amount 1, cooldown 150 s). cost = file <cost>; each recast adds <repeatcost> 5 favor. Turns enemy land military units (not heroes) in 20 m into pigs, up to 800 resources of units. activetime 3 s."
    }
  },
  {
    "id": "earthquake",
    "name": {
      "pt-BR": "Terremoto",
      "en": "Earthquake"
    },
    "icon": "powers/earthquake",
    "pantheon": "greeks",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "effect": {
      "kind": "military",
      "duration": 12
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Artemis (MythicAgeArtemis grants it: GodPower amount 1, cooldown 240 s). cost = file <cost>; each recast adds <repeatcost> 5 favor. Damages units and buildings in 35 m (epicenter 100%, middle 50%, outer 20%). activetime 12 s."
    }
  },
  {
    "id": "lightning-storm",
    "name": {
      "pt-BR": "Tempestade de Raios",
      "en": "Lightning Storm"
    },
    "icon": "powers/lightning-storm",
    "pantheon": "greeks",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "castTime": 1.3,
    "effect": {
      "kind": "military",
      "duration": 15
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Hera (MythicAgeHera grants it: GodPower amount 1, cooldown 240 s). cost = file <cost>; each recast adds <repeatcost> 5 favor. Lightning strikes enemy units and buildings in 40 m (not farms or settlements). activetime 15 s."
    }
  },
  {
    "id": "lure",
    "name": {
      "pt-BR": "Isca",
      "en": "Lure"
    },
    "icon": "powers/lure",
    "pantheon": "greeks",
    "cost": {
      "favor": 20
    },
    "cooldown": 60,
    "effect": {
      "kind": "economy"
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Poseidon (ArchaicAgePoseidon grants it: GodPower amount 1, cooldown 60 s). cost = file <cost>; each recast adds <repeatcost> 5 favor. Places a Lure (food drop site) that attracts Herdable/Huntable animals within 50-200 m and spawns Chickens (100 food each): 3/4/6/10 in Archaic/Classical/Heroic/Mythic; lured food capped at 1200/1300/1500/1900. Chickens are not Greek unit ids, so no spawn is given. activetime -1 s."
    }
  },
  {
    "id": "pestilence",
    "name": {
      "pt-BR": "Pestilência",
      "en": "Pestilence"
    },
    "icon": "powers/pestilence",
    "pantheon": "greeks",
    "cost": {
      "favor": 50
    },
    "cooldown": 120,
    "effect": {
      "kind": "military",
      "duration": 60
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Ares (ClassicalAgeAres grants it: GodPower amount 1, cooldown 120 s). cost = file <cost>; each recast adds <repeatcost> 10 favor. Enemy military buildings, Docks and towers in 50 m: rate of fire penalty and train rate penalty x2.5. activetime 60 s."
    }
  },
  {
    "id": "plenty",
    "name": {
      "pt-BR": "Abundância",
      "en": "Plenty"
    },
    "icon": "powers/plenty",
    "pantheon": "greeks",
    "cost": {
      "favor": 300
    },
    "cooldown": 180,
    "effect": {
      "kind": "economy",
      "trickle": {
        "food": 210,
        "wood": 210,
        "gold": 210
      }
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Hephaestus (MythicAgeHephaestus grants it: GodPower amount 1, cooldown 180 s). cost = file <cost>; each recast adds <repeatcost> 200 favor. Creates a permanent Plenty Vault with AutoGather 3.5 food, 3.5 wood and 3.5 gold per second (210/min each). activetime 3 s."
    }
  },
  {
    "id": "restoration",
    "name": {
      "pt-BR": "Restauração",
      "en": "Restoration"
    },
    "icon": "powers/restoration",
    "pantheon": "greeks",
    "cost": {
      "favor": 125
    },
    "cooldown": 180,
    "effect": {
      "kind": "utility",
      "duration": 6
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Athena (ClassicalAgeAthena grants it: GodPower amount 1, cooldown 180 s). cost = file <cost>; each recast adds <repeatcost> 25 favor. Heals own/allied units and buildings in a 25 m radius (healspeed 50). activetime 6 s."
    }
  },
  {
    "id": "sentinel",
    "name": {
      "pt-BR": "Sentinela",
      "en": "Sentinel"
    },
    "icon": "powers/sentinel",
    "pantheon": "greeks",
    "cost": {
      "favor": 60
    },
    "cooldown": 90,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Hades (ArchaicAgeHades grants it: GodPower amount 1, cooldown 90 s). cost = file <cost>; each recast adds <repeatcost> 10 favor. Creates 5 permanent Sentinels (20-26 m) around an own or allied fully built unit target (LogicalTypeValidSentinelTarget). activetime 3 s."
    }
  },
  {
    "id": "underworld-passage",
    "name": {
      "pt-BR": "Passagem do Mundo Inferior",
      "en": "Underworld Passage"
    },
    "icon": "powers/underworld-passage",
    "pantheon": "greeks",
    "cost": {
      "favor": 200
    },
    "cooldown": 180,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (greek.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Apollo (HeroicAgeApollo grants it: GodPower amount 1, cooldown 180 s). cost = file <cost>; each recast adds <repeatcost> 25 favor. Two linked portals (at least 30 m apart). activetime -1 s."
    }
  },
  {
    "id": "dwarven-mine",
    "name": {
      "pt-BR": "Mina Enânica",
      "en": "Dwarven Mine"
    },
    "icon": "powers/dwarven-mine",
    "pantheon": "norse",
    "cost": {
      "favor": 75
    },
    "cooldown": 120,
    "effect": {
      "kind": "economy"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Thor (Archaic). Cost 75, repeatcost +50, cooldown 120. Creates a Dwarven Mine with 500 / 1000 / 3000 / 6000 gold (Archaic..Mythic), gathered x1.0 / x1.1 / x1.25 / x1.5 faster. Not modelled. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "fimbulwinter",
    "name": {
      "pt-BR": "Fimbulwinter",
      "en": "Fimbulwinter"
    },
    "icon": "powers/fimbulwinter",
    "pantheon": "norse",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "castTime": 6,
    "effect": {
      "kind": "military",
      "duration": 25
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Tyr (Mythic). Cost 350, repeatcost +55, cooldown 240. 6 s build-up, active 25 s; wolf packs attack enemy settlements. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "flaming-weapons",
    "name": {
      "pt-BR": "Armas Flamejantes",
      "en": "Flaming Weapons"
    },
    "icon": "powers/flaming-weapons",
    "pantheon": "norse",
    "cost": {
      "favor": 250
    },
    "cooldown": 210,
    "effect": {
      "kind": "military",
      "duration": 45
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Bragi (Heroic). Cost 250, repeatcost +50, cooldown 210. Damage x1.60 (Percent) for 45 s. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "forest-fire",
    "name": {
      "pt-BR": "Incêndio Florestal",
      "en": "Forest Fire"
    },
    "icon": "powers/forest-fire",
    "pantheon": "norse",
    "cost": {
      "favor": 125
    },
    "cooldown": 180,
    "effect": {
      "kind": "military",
      "duration": 30
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Freyja (Classical). Cost 125, repeatcost +50, cooldown 180. Active 30 s. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "frost",
    "name": {
      "pt-BR": "Congelamento",
      "en": "Frost"
    },
    "icon": "powers/frost",
    "pantheon": "norse",
    "cost": {
      "favor": 200
    },
    "cooldown": 240,
    "effect": {
      "kind": "military",
      "duration": 45
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Skadi (Heroic). Cost 200, repeatcost +15, cooldown 240. Freezes enemies in 23 m for 45 s. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "great-hunt",
    "name": {
      "pt-BR": "Grande Caça",
      "en": "Great Hunt"
    },
    "icon": "powers/great-hunt",
    "pantheon": "norse",
    "cost": {
      "favor": 25
    },
    "cooldown": 90,
    "effect": {
      "kind": "economy"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Odin (Archaic). Cost 25, repeatcost +5 per further cast, cooldown 90. Multiplies the huntables in a 10 m radius up to maxfood 500 / 600 / 1200 / 2100 food (Archaic..Mythic); spawns Elk if none. Food not modelled. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "healing-spring",
    "name": {
      "pt-BR": "Fonte de Cura",
      "en": "Healing Spring"
    },
    "icon": "powers/healing-spring",
    "pantheon": "norse",
    "cost": {
      "favor": 100
    },
    "cooldown": 150,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Forseti (Classical). Cost 100, repeatcost +150, cooldown 150. Creates a permanent Healing Spring. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "nidhogg",
    "name": {
      "pt-BR": "Nidhogg",
      "en": "Nidhogg"
    },
    "icon": "powers/nidhogg",
    "pantheon": "norse",
    "cost": {
      "favor": 350
    },
    "cooldown": 240,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Hel (Mythic). Cost 350, repeatcost +50, cooldown 240. Creates the Nidhogg dragon. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "ragnarok",
    "name": {
      "pt-BR": "Ragnarok",
      "en": "Ragnarok"
    },
    "icon": "powers/ragnarok",
    "pantheon": "norse",
    "cost": {
      "favor": 250
    },
    "cooldown": 300,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Baldr (Mythic). Cost 250, repeatcost +50, cooldown 300. Turns every Gatherer and Dwarf into a Hero of Ragnarok. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "spy",
    "name": {
      "pt-BR": "Espião",
      "en": "Spy"
    },
    "icon": "powers/spy",
    "pantheon": "norse",
    "cost": {
      "favor": 30
    },
    "cooldown": 30,
    "effect": {
      "kind": "utility"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Loki (Archaic). Cost 30, repeatcost +5, cooldown 30. Shows an enemy unit's line of sight. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "undermine",
    "name": {
      "pt-BR": "Desmoronar",
      "en": "Undermine"
    },
    "icon": "powers/undermine",
    "pantheon": "norse",
    "cost": {
      "favor": 50
    },
    "cooldown": 150,
    "effect": {
      "kind": "military",
      "duration": 15
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Heimdall (Classical). Cost 50, repeatcost +10, cooldown 150. Active 15 s; instantly destroys walls and Sentry Towers on its path, damages other buildings. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  },
  {
    "id": "walking-woods",
    "name": {
      "pt-BR": "Árvores Andantes",
      "en": "Walking Woods"
    },
    "icon": "powers/walking-woods",
    "pantheon": "norse",
    "cost": {
      "favor": 100
    },
    "cooldown": 180,
    "effect": {
      "kind": "military"
    },
    "meta": {
      "source": "Game files 19.17020 (god_powers/norse.godpowers, techtree.xml)",
      "checkedAt": "2026-10-18",
      "confidence": "high",
      "note": "Njord (Heroic). Cost 100, repeatcost +50, cooldown 180. Turns 7 trees in 8 m into Walking Woods. Cost is the godpowers <cost>; each further cast adds <repeatcost>. Cooldown from the age tech GodPower effect. Whether the first cast is free is not stated in these files."
    }
  }
]
